
















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";

@Component
export default class UMenu extends Vue {
  @Prop({ required: true })
  public routes!: IMenuRoute[];

  @Prop({
    default: "default",
    validator: value => {
      return ["exact", "default"].includes(value);
    }
  })
  public precision!: "exact" | "default";

  @Prop({ default: false })
  public sortable!: boolean;

  public sortElems!: any[];

  public sortableOptions: {
    chosenClass: string;
    handle: string;
  } = {
    chosenClass: "is-selected",
    handle: ".drag-and-drop"
  };

  public created() {
    if (this.sortable) {
      this.sortElems = this.$_.cloneDeep(this.routes);
    }
  }
  // Getters
  public get vm() {
    return this;
  }

  public get isPrecise() {
    return this.precision === "exact";
  }

  // Methods
  public filterRoutes(routes) {
    return this.$_.filter(routes, route => {
      return this.$_.get(route, "if", () => true)(this);
    });
  }

  public itemIsActive(item, isActive) {
    return item.isActive
      ? item.isActive(this.$router.currentRoute, isActive)
      : isActive;
  }

  public label(label) {
    return label.startsWith("_") ? this.$t(label) : label;
  }

  public onDragDrop() {
    this.$emit("onDragDrop", this.sortElems);
  }
}
